<template>
  <div id="page" :class="{fixed: confirmDialog}">
    <div class="app-content invite-container" :class="{show: show}" :style="color ? {backgroundColor: 'rgba(' + color  +',0.8)'} : {}">
      <div class="invite-banner" :style="background ? {backgroundImage: 'url(' + background.path + ')'} : {}"></div>
      <div class="invite-marquee" id="marquee_box" style="display: none;">
        <ul class="invite-marquee-box">
          <li>用户一</li>
          <li>用户二</li>
          <li>用户三</li>
          <li>用户四</li>
        </ul>
      </div>
      <div class="invite-section">
        <div class="invite-secition-angle" :style="color ? {background: 'rgba(' + color  +',1)'} : {}">
          <span>邀请码用于邀请好友注册，自定义邀请码方便传播，更便于推广</span>
        </div>
        <div class="invite-section-inner">
          <p class="invite-desc" v-if="!disabled">邀请<span class="invite-color">{{inviteAmount}}</span>个有效粉丝获得一个自定义邀请码</p>
          <p class="invite-desc" v-else>暂无活动，敬请期待！</p>
          <div class="invite-result">
            <div>已经邀请<span class="invite-color" id="totalnum">{{userFans.length}}</span>个</div>
            <div class="invite-btn" id="optbtn" @click="onClickBtn"><template v-if="isInit">{{ !disabled && userFans.length >= inviteAmount ? '去设置' : '去邀请'}}</template></div>
          </div>
          <div class="invite-list">
            <div class="invite-list-item" v-for="item of userFans" :key="item.mobile">
              <img :src="item.avatar" class="user-avater" alt="">
              <span class="invite-user">粉丝 {{item.mobile}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="invite-section">
        <div class="invite-section-inner activity-regular">
          <h3>活动说明</h3>
          <ul class="list" v-if="isInit">
            <li v-for="(item, key) in pageReminder" :key="key" v-html="item"></li>
          </ul>
        </div>
      </div>
      <transition name="fade">
        <div v-if="showLoading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
            <p class="weui-toast__content">加载中...</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{toastMsg}}</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showSuccToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <i class="weui-icon-success-no-circle weui-icon_toast"></i>
            <p class="weui-toast__content">设置成功</p>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="confirmDialog" class="confirm-dialog">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
            <div class="weui-dialog__hd">
              <strong class="weui-dialog__title">专属邀请码</strong>
              <span class="weui-dialog__subtitle">设置专属的邀请码，更容易被记住，<br/>邀粉更方便哦！</span>
              <button class="weui-icon-btn close" @click="onCancel"><i class="weui-icon-close-thin"></i></button>
            </div>
            <div class="weui-dialog__bd">
              <div class="desc">可以支持中文、英文、数字任意2-7个字符</div>
              <div class="input"><input type="text" v-model="inviteCode" placeholder="请输入2-7个字符邀请码"></div>
            </div>
            <div class="weui-dialog__ft">
              <a href="javascript:" class="weui-btn weui-btn_primary" @click="onSubmit">立即设置</a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="less" scoped>
#page {
  min-height: 100vh;
}
#page.fixed {
  height: 100vh;
  overflow: hidden;
}
.app-content {
  height: 100vh;
  background-color: #4F52E4;
  overflow-y: auto;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.app-content.show {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

#toast {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 10px;
  border-radius: 3px;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.hide {
  display: none;
}

.fadeOut {
  animation: fadeOut .5s;
}

.fadeIn {
  animation: fadeIn .5s;
}

.invite-color {
  color: #E64771;
}

.invite-container {
  box-sizing: border-box;
  position: relative;
}

.invite-container .invite-banner {
  height: 8.8rem;
  background: url('../assets/images/act_banner.png') no-repeat;
  background-size: 100% auto;
}

.invite-container .invite-marquee {
  width: 100%;
  height: 1.04rem;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.2);
  overflow: hidden;
  font-size: 0.48rem;
  text-align: center;
}

.invite-container .invite-marquee .invite-marquee-box {
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  height: auto;
}

.invite-container .invite-marquee .invite-marquee-box li {
  height: 1.04rem;
  line-height: 1.04rem;
  color: #fff;
}

.invite-container .invite-section {
  box-sizing: border-box;
  width: 14.48rem;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 0.6rem;
  margin: 0.48rem auto;
  padding: 0.36rem 0.4rem;
  position: relative;
}

.invite-container .invite-section .invite-section-inner {
  width: 100%;
  height: auto;
  min-height: 4.84rem;
  background: #fff;
  border-radius: 0.48rem;
  box-sizing: border-box;
  padding: 0 0.4rem;
  overflow: hidden;
}

.invite-container .invite-section .invite-section-inner ul {
  list-style: none;
}

.invite-container .invite-section .invite-section-inner.activity-regular {
  padding: 0.28rem 0.36rem 0.56rem 0.4rem;
}

.invite-container .invite-section .invite-section-inner.activity-regular h3 {
  font-size: 0.56rem;
  color: #1F1F1F;
}

.invite-container .invite-section .invite-section-inner.activity-regular p {
  font-size: 0.48rem;
  color: #555555;
  line-height: 0.84rem;
}

.invite-container .invite-section .invite-secition-angle {
  position: absolute;
  height: 2.08rem;
  width: 10.72rem;
  background: url('../assets/images/top_angle.png') no-repeat;
  background-size: 100% auto;
  top: 0;
  left: 50%;
  transform: translate(-50%, -40%);
  font-size: 0.48rem;
  color: #fff;
  box-sizing: border-box;
  padding: 0.36rem 0.54rem 0.36rem 0.56rem;
  border-radius: 8px;
}

.invite-container .invite-section .invite-secition-angle .svg {
  position: absolute;
  left: 0;
  top: 0;
  height: 2.08rem;
  width: 10.72rem;
}
.invite-container .invite-section .invite-secition-angle span {
  position: relative;
  z-index: 9;
}
.invite-container .invite-section .invite-desc {
  font-size: 0.56rem;
  color: #1F1F1F;
  font-weight: bold;
  margin-top: 1.64rem;
}

.invite-container .invite-section .invite-result {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.56rem;
  color: #1F1F1F;
  font-weight: bold;
  margin-top: 0.52rem;
}

.invite-container .invite-section .invite-btn {
  width: 4rem;
  height: 1.2rem;
  background: #E64771;
  border-radius: 0.6rem;
  font-size: 0.56rem;
  color: #FFFFFF;
  text-align: center;
  line-height: 1.25rem;
  cursor: pointer;
  overflow: hidden;
}

.invite-container .invite-section .invite-list-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 2.08rem;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.invite-container .invite-section .invite-list-item:after {
  content: '';
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #F5F5F5;
}

.invite-container .invite-section .invite-list-item .user-avater {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}

.invite-container .invite-section .invite-list-item .invite-user {
  color: #555555;
  font-size: 0.56rem;
}

.notice-animate {
  transition: all .3s ease-out;
}

.confirm-dialog .weui-dialog__hd {
  position: relative;
  padding: 16px 24px 8px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px #efefef solid;
}

.confirm-dialog .weui-dialog__hd .close {
  position: absolute;
  top: 14px;
  right: 14px;
}

.confirm-dialog .weui-dialog__title {
  font-size: 16px;
  font-weight: 600;
}
.confirm-dialog .weui-dialog__subtitle {
  font-size: 13px;
  color: #999;
  padding-top: 4px;
}

.confirm-dialog .weui-dialog__bd {
  padding-top: 4px;
  padding-bottom: 0;
  margin-bottom: 20px;
  text-align: left;
}

.confirm-dialog .weui-dialog__bd .desc {
  font-size: 13px;
  color: red;
  padding-top: 10px;
  padding-bottom: 5px;
}

.confirm-dialog .weui-dialog__bd .input input {
  height: 40px;
  line-height: 40px;
  border: 0;
  border-radius: 6px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #efefef;
  font-size: 16px;
  width: 100%;
  outline:none;
}

.confirm-dialog .weui-dialog__ft:after {
  display: none;
}

.confirm-dialog .weui-dialog__ft {
  padding-bottom: 14px;
  .weui-btn_primary {
    width: 60%;
    padding: 0;
    margin: 0 auto;
    background-color: #d8c078;
    color: #fff;
    font-weight: 500;
    border-radius: 20px;
    height: 44px;
    line-height: 46px;
  }
}

</style>

<script>
import request from "@/pages/mobile/utils/request";
import moment from 'moment';

export default {
  name: 'home',
  data() {
    return {
      show: false,
      showLoading: true,
      confirmDialog: false,
      showToast: false,
      showSuccToast: false,
      checkUserInfo: false,
      checkAppKey: false,
      isWxPay: false,
      isAliPay: false,
      background: null,
      color: null,
      isInit: false,
      memberId: null,
      userInfo: {},
      userFans: [],
      inviteAmount: 0,
      activity: null,
      disabled: false,
      inviteCode: null,
      appEnv: {
        prod: true,
        appId: '',
        appKey: '',
        platformId: null,
      },
    };
  },
  created() {
    this.appEnv.prod = process.env.VUE_APP_RELEASE === 'prod';
    if (!this.appEnv.prod) {
      this.appEnv.appId = 'CC202104110012172897';
      this.appEnv.appKey = 'EDF0763043A073BC';
      this.appEnv.platformId = 9;
      this.userInfo = {
        id: 113505,
        mobile: '18958906820',
        invite_code: "57392186",
        avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
        nickname: "文贤",
        jointime_text: '2021-06-10 15:00:34',
        agent_name: '中级VIP'
      };
      new VConsole();
    }
  },
  mounted() {
    const appId = this.$route.query.appid ||'';
    const platformId = this.$route.query.platformid || '';
    const uid = this.$route.query.uid || 0;

    if (appId) this.appEnv.appId = appId;
    if (platformId) this.appEnv.platformId = parseInt(platformId, 10) || 0;
    if (uid) this.userInfo.id = parseInt(uid, 10);
    if (!this.appEnv.appId) {
      this.showLoading = false;
      this.show = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    const h5Userinfo = getH5UserInfo();
    if (h5Userinfo) {
      new Promise(async () => {
        await h5Userinfo.then((resp) => {
          this.checkUserInfo = true;
          this.userInfo = JSON.parse(resp);
        }).catch((err) => {
          this.showLoading = false;
          this.show = true;
          if (typeof err === 'object') {
            this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
          } else if (typeof  err === 'string') {
            this.toast('未能获取到用户信息请联系客服: ' + err);
          }
        });
        let appKey = '';
        this.showLoading = true;
        await checkAppInfo().then(version => {
          appKey = version;
        }).catch((err) => {});
        await this.getTenantCfg(appKey).catch(err => {});
        await this.appMemberLink().catch(err => {});
        await this.getCodeActivity().catch(err => {});
        this.show = true;
        setTimeout(() => {
          this.showLoading = false;
          if (!this.activity) {
            this.disabled = true;
            this.isInit = true;
          } else {
            this.getMemberFans();
          }
        }, 150);
      });
    } else {
      if (!this.appEnv.prod) {
        this.showLoading = true;
        new Promise(async () => {
          await this.getTenantCfg(this.appEnv.appKey).catch(err => {});
          await this.appMemberLink().catch(err => {});
          await this.getCodeActivity().catch(err => {});
          this.show = true;
          setTimeout(() => {
            this.showLoading = false;
            if (!this.activity) {
              this.disabled = true;
              this.isInit = true;
            } else {
              this.getMemberFans();
            }
          }, 150);
        });
      } else {
        this.showLoading = false;
        this.show = true;
        this.toast('未能获取到用户信息请联系客服');
      }
    }
  },
  watch: {
  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.checkUserInfo;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, nickname: this.userInfo.nickname, msg: v},
        }).then().catch(err => {})
      }
    },
    onClickBtn() {
      if (this.userFans.length >= this.inviteAmount && !this.disabled) {
        this.confirmDialog = true;
      } else {
        openAppchannel('InviteSharePage');
      }
    },
    getCodeActivity() {
      const newRequest = request({
        url: `/open/api/code/activity`,
        method: 'GET',
        params: {uid: this.userInfo.id, appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, invite_code: this.userInfo.invite_code}
      });
      newRequest.then((resp) => {
        if (resp.id) {
          this.activity = resp;
          if (this.activity.rule_user_type === 1) {
            const findOne = resp.levels.find(t => t.user_level === this.userInfo.agent_name)
            if (findOne) {
              this.inviteAmount = findOne.amount;
            } else {
              this.disabled = true;
            }
          } else {
            this.inviteAmount = this.activity.rule_user_number;
          }
        }
      });
      return newRequest;
    },
    getMemberFans() {
      const newRequest = request({
        url: '/open/api/activity/member/fans',
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          inviteCode: this.userInfo.invite_code,
          activityId: this.activity.id,
          levelName: this.userInfo.agent_name,
        }
      });
      newRequest.then((resp) => {
        this.userFans = resp.list;
        this.isInit = true;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
        this.isInit = true;
      })
      return newRequest;
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version }
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, page_reminder, background, color} = resp;
        this.appEnv.appKey = version;
        this.background = background;
        this.color = color ? this.colorRgb(color).join(',') : null;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.checkAppKey = appkey === version;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onCancel() {
      this.confirmDialog = false;
      this.inviteCode = null;
    },
    onSubmit() {
      this.confirmDialog = false;
      this.showLoading = true;
      const newRequest = request({
        url: '/open/api/member/invite-code',
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          invite_code: this.userInfo.invite_code,
          activityId: this.activity.id,
          memberId: this.memberId,
          code: this.inviteCode,
        }
      });
      newRequest.then((resp) => {
        this.inviteCode = null;
        this.showLoading = false;
        this.showSuccToast = true;
        setTimeout(() => {
          this.showSuccToast = false;
        }, 2000)
      }).catch((error) => {
        this.inviteCode = null;
        this.showLoading = false;
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    colorRgb(hexColor) {
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      let sColor = hexColor.toLowerCase()
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = '#'
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        var sColorChange = []
        for (var j = 1; j < 7; j += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(j, j + 2)))
        }
        return sColorChange
      } else {
        return sColor
      }
    }
  }
}
</script>
